import { gql } from '@parkchirp/api-client';

export const GET_TICKET_REC_ORG_SETTINGS = gql`
    query getTicketRecOrgSettings(
        $organizationId: Int!
    ) {
        getTicketRecOrgSettings(
            organizationId: $organizationId
        ) {
            dailyReportTicketColors {
                id,
                code,
                description
            },
            dailyReportSequenceReasons {
                id,
                code,
                description
            },
            dailyReportVarianceReasons {
                id,
                code,
                description
            },
            ticketRecVarianceThreshold
        }
    }
`;

export const GET_ORGANIZATION_PAYMENT_PROVIDERS = gql`
    query getOrganizationPaymentProviders($organizationId: Int!) {
        getOrganizationPaymentProviders(organizationId: $organizationId) {
            paymentProviderId
        }
    }
`;
